import React from "react";
import PropTypes from "prop-types";
import AcmgPill from "../../acmg-pill";
import { getAllActiveRulesStrengths, getEnchancedRules } from "../../helpers";

const ManualComponentOverride = ({
  acmgRules,
  classifications,
  showSummaryView,
  allRulesToggleState,
  onToggleHandle,
  onAcmgSelectChange,
  shouldShowACMGPoints,
  activeOverrideStrengths,
  rulesThatMetCriteria,
}) => {
  const enchancedAcmgRules = getEnchancedRules({
    acmgRules,
    classifications,
  });

  const activeRules = getAllActiveRulesStrengths(
    activeOverrideStrengths,
    rulesThatMetCriteria
  );

  return (
    showSummaryView &&
    enchancedAcmgRules && (
      <div className="tw-pt-1 tw-pb-2">
        <div className="tw-py-1">
          <h6>Pathogenic</h6>
          <div className="tw-flex tw-flex-wrap">
            {enchancedAcmgRules
              .filter((r) => r.name.charAt(0) === "P")
              .map((r, index) => {
                const key = `${r.name}${index}${Date.now()}`;
                return (
                  <AcmgPill
                    key={key}
                    classification={r}
                    hasMargins={true}
                    showExplanation={true}
                    activeRules={activeRules}
                    rulesToggleState={allRulesToggleState}
                    onToggleHandle={onToggleHandle}
                    onSelectChange={onAcmgSelectChange}
                    shouldShowPointsReference={shouldShowACMGPoints}
                  />
                );
              })}
          </div>
        </div>
        <div className="tw-py-1">
          <h6>Benign</h6>
          <div className="tw-flex tw-flex-wrap">
            {enchancedAcmgRules
              .filter((r) => r.name.charAt(0) === "B")
              .map((r, index) => {
                const key = `${r.name}${index}${Date.now()}`;
                return (
                  <AcmgPill
                    key={key}
                    classification={r}
                    hasMargins={true}
                    showExplanation={true}
                    activeRules={activeRules}
                    rulesToggleState={allRulesToggleState}
                    onToggleHandle={onToggleHandle}
                    onSelectChange={onAcmgSelectChange}
                    shouldShowPointsReference={shouldShowACMGPoints}
                  />
                );
              })}
          </div>
        </div>
      </div>
    )
  );
};

ManualComponentOverride.propTypes = {
  showSummaryView: PropTypes.bool.isRequired,
  acmgRules: PropTypes.arrayOf(
    PropTypes.shape({
      evidence: PropTypes.string,
      met_criteria: PropTypes.bool,
      user_explain_failed: PropTypes.arrayOf(PropTypes.string),
      acmg_triggered_strength: PropTypes.string,
      name: PropTypes.string,
    })
  ),
  classifications: PropTypes.arrayOf(PropTypes.shape({})),
  activeOverrideStrengths: PropTypes.shape({}).isRequired,
  allRulesToggleState: PropTypes.shape({}).isRequired,
  onToggleHandle: PropTypes.func.isRequired,
  onAcmgSelectChange: PropTypes.func.isRequired,
  shouldShowACMGPoints: PropTypes.bool.isRequired,
  rulesThatMetCriteria: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

ManualComponentOverride.defaultProps = {
  acmgRules: undefined,
  classifications: undefined,
};

export default ManualComponentOverride;
